import { render } from "./DisplayCurrentWeek.vue?vue&type=template&id=764b9135"
import script from "./DisplayCurrentWeek.vue?vue&type=script&lang=js"
export * from "./DisplayCurrentWeek.vue?vue&type=script&lang=js"

import "./DisplayCurrentWeek.vue?vue&type=style&index=0&id=764b9135&lang=css"

import exportComponent from "/home/tchery/dev/assiette-parfaite/frontend-gesit/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__